import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientsCountriesQuery } from 'api/generated/graphql';
import { parseCountryEntity, useError } from 'api/helpers';
import { lodash } from 'helpers';

export const useLegalClientsCountries = () => {
  const { data, loading, error: apolloError } = useLegalClientsCountriesQuery();

  const error = useError(apolloError);

  return {
    countriesData: useMemo(
      () =>
        data?.legalClientsCountries
          ? {
              registration: lodash
                .compact(data?.legalClientsCountries.legal)
                .map(parseCountryEntity),
              location: lodash
                .compact(data?.legalClientsCountries.actual)
                .map(parseCountryEntity),
            }
          : undefined,
      [data?.legalClientsCountries]
    ),
    loading,
    error,
  };
};
